import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { DocumentListItem, IDocumentListItem } from "./documentListItem";

export interface IDocumentListItems extends IListItems<IDocumentListItem> {}

export class DocumentListItems extends ListItems<DocumentListItem> implements IDocumentListItems {
    constructor();
    constructor(obj: IDocumentListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, DocumentListItem);
    }
}